import React, { Component } from "react";
import Layout from "../../Layout/layout";
import "../../styles/alerts/alerts.scss";
import { Helmet } from "react-helmet";
import { Badge } from "react-bootstrap";
import AlertTable from "./alertTable";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import axios from "axios";
import queryString from "query-string";
import signalRHelper from "../../utils/signalRHelper";
import { downloadCSVFile, apiHost } from "../../api/apiClient";

class alerts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertsDuressList: [],
      alertsBehaviourList: [],
      alertsTemperatureList: [],
      activeTab: 1,
      duressTotal: 0,
      behaviourTotal: 0,
      temperatureTotal: 0,
      pendingDuress: 0,
      pendingBehaviour: 0,
      pendingTemperature: 0,
      rowColor: false,
    };
  }

  componentDidMount() {
    this.setActiveTab();
    this.getEventlists();
  }

  componentWillUnmount() {
    this.releaseSignalR();
  }

  releaseSignalR() {
    if (!this.connection) {
      return;
    }

    // Release signalR handlers
    signalRHelper.unsubscribe("Duress");
    signalRHelper.unsubscribe("Behaviour");
    signalRHelper.unsubscribe("Temperature");

    this.connection.off("Duress");
    this.connection.off("Behaviour");
    this.connection.off("Temperature");
    this.connection = null;
  }

  setActiveTab = () => {
    let search = queryString.parse(this.props.location.search);
    console.log("search", search);

    if (search.alert === "duress") {
      this.setState({
        activeTab: 1,
      });
    } else if (search.alert === "temperature") {
      this.setState({
        activeTab: 3,
      });
    } else {
      this.setState({
        activeTab: 2,
      });
    }
  };

  getEventlists = async () => {
    try {
      this.props.setLoadingPageAction(true);
      let alertsList = await axios.get(`${apiHost}/api/Event/GetLatestEvents`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      this.setState({
        alertsDuressList: alertsList.data.Duress,
        alertsBehaviourList: alertsList.data.Behavior,
        alertsTemperatureList: alertsList.data.Temperature || [],
      });
      this.handleSignalR();
      await this.PendingAlertCalculation();
      this.props.setLoadingPageAction(false);
    } catch (e) {
      this.props.setLoadingPageAction(false);
      this.props.setErrorMessageAction(`${e}`);
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  componentDidUpdate(prevProps) {
    if (this.props.location.search !== prevProps.location.search) {
      window.location.reload(false);
    }
  }

  async handleSignalR() {
    this.connection = await signalRHelper.getConnection();
    this.addAlerts();
  }

  addAlerts = () => {
    signalRHelper.subscribe("Duress");
    signalRHelper.subscribe("Behaviour");
    signalRHelper.subscribe("Temperature");

    this.connection.on("Duress", (data) => {
      this.data = data;
      console.log("entry Duress");
      console.log(data);
      this.createDuressList(data);
    });

    this.connection.on("Behaviour", (data) => {
      this.data = data;
      console.log("entry Behaviour");
      console.log(data);
      this.createBehaviourList(data);
    });

    this.connection.on("Temperature", (data) => {
      this.data = data;
      console.log("entry Temperature");
      console.log(data);
      this.createTemperatureList(data);
    });
  };

  createDuressList = async (data) => {
    let counter = 0;
    let currentList = [...this.state.alertsDuressList];

    if (data !== undefined) {
      await this.PendingAlertCalculation();
      let alertsList = await axios.get(`${apiHost}/api/Event/GetLatestEvents?LastSentTime=${data}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      console.log("alertsList duress", alertsList);
      data = alertsList.data.Duress;
      this.setState({ rowColor: true });

      currentList = currentList
        .map((item) => {
          const { rowColor, ...rest } = item;
          return rest;
        })
        .map((item) => {
          if (item.id == data.id) {
            counter++;
            return data;
          }
          return item;
        });

      if (counter == 0) {
        data.forEach((item, index) => {
          item.rowColor = this.state.rowColor;
          currentList.push(item);
        });
      }

      currentList.sort(function (x, y) {
        var date1 = new Date(this.getAlertTimestamp(x));
        var date2 = new Date(this.getAlertTimestamp(y));
        return date2 - date1;
      }.bind(this));

      this.setState({ alertsDuressList: currentList });

      setTimeout(() => {
        let currentList = [...this.state.alertsDuressList];
        currentList = currentList.map((item) => {
          const { rowColor, ...rest } = item;
          return rest;
        });
        this.setState({ alertsDuressList: currentList });
      }, 5000);
    }
  };

  createBehaviourList = async (data) => {
    let counter = 0;
    let currentList = [...this.state.alertsBehaviourList];

    if (data !== undefined) {
      await this.PendingAlertCalculation();
      let alertsList = await axios.get(`${apiHost}/api/Event/GetLatestEvents?LastSentTime=${data}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      console.log("alertsList behaviour", alertsList);
      data = alertsList.data.Behavior;
      this.setState({ rowColor: true });

      currentList = currentList
        .map((item) => {
          const { rowColor, ...rest } = item;
          return rest;
        })
        .map((item) => {
          if (item.id == data.id) {
            counter++;
            return data;
          }
          return item;
        });

      if (counter == 0) {
        data.forEach((item, index) => {
          item.rowColor = this.state.rowColor;
          currentList.push(item);
        });
      }

      currentList.sort(function (x, y) {
        var date1 = new Date(this.getAlertTimestamp(x));
        var date2 = new Date(this.getAlertTimestamp(y));
        return date2 - date1;
      }.bind(this));
      this.setState({ alertsBehaviourList: currentList });

      setTimeout(() => {
        let currentList = [...this.state.alertsBehaviourList];
        currentList = currentList.map((item) => {
          const { rowColor, ...rest } = item;
          return rest;
        });

        this.setState({
          alertsBehaviourList: currentList,
        });
      }, 5000);
    }
  };

  createTemperatureList = async (data) => {
    let counter = 0;
    let currentList = [...this.state.alertsTemperatureList];

    if (data !== undefined) {
      await this.PendingAlertCalculation();
      let alertsList = await axios.get(`${apiHost}/api/Event/GetLatestEvents?LastSentTime=${data}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      console.log("alertsList temperature", alertsList);
      data = alertsList.data.Temperature || [];
      this.setState({ rowColor: true });

      currentList = currentList
        .map((item) => {
          const { rowColor, ...rest } = item;
          return rest;
        })
        .map((item) => {
          if (item.id == data.id) {
            counter++;
            return data;
          }
          return item;
        });

      if (counter == 0 && data.length > 0) {
        data.forEach((item, index) => {
          item.rowColor = this.state.rowColor;
          currentList.push(item);
        });
      }

      currentList.sort(function (x, y) {
        var date1 = new Date(x.tempAlertStartTime || x.created);
        var date2 = new Date(y.tempAlertStartTime || y.created);
        return date2 - date1;
      });
      
      this.setState({ alertsTemperatureList: currentList });

      setTimeout(() => {
        let currentList = [...this.state.alertsTemperatureList];
        currentList = currentList.map((item) => {
          const { rowColor, ...rest } = item;
          return rest;
        });

        this.setState({
          alertsTemperatureList: currentList,
        });
      }, 5000);
    }
  };

  handleTab = (number) => {
    this.setState({ activeTab: number });
  };

  getAlertTimestamp = (alert) => {
    if (!alert) {
      return null;
    }

    return alert.tempAlertStartTime || alert.gPRMC?.created || alert.created || alert.received;
  };

  handleAcknowledge = async (id, description) => {
    let url = `${apiHost}/api/Event/EventAcknowledgement`;

    this.props.setLoadingPageAction(true);
    this.setState({ rowColor: true });
    try {
      await axios.post(
        url,
        {
          MessageId: id,
          Acknowledgement: description,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.getEventlists();
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);
      console.log(`😱 Axios request failed: ${e}`);
    }
    this.setState({ rowColor: false });
  };

  PendingAlertCalculation = async () => {
    let alertsList = await axios.get(`${apiHost}/api/Event/GetLatestEventsWithCount?CountOnly=true`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    });

    this.setState({
      behaviourTotal: alertsList.data.TotalBehavior,
      pendingBehaviour: alertsList.data.PendingBehavior,
      duressTotal: alertsList.data.TotalDuress,
      pendingDuress: alertsList.data.PendingDuress,
      temperatureTotal: alertsList.data.TotalTemperature || 0,
      pendingTemperature: alertsList.data.PendingTemperature || 0,
    });
  };

  handleDownloadBehaviour = () => {
    downloadCSVFile(this.state.alertsBehaviourList);
  };

  handleDownloadDuress = () => {
    downloadCSVFile(this.state.alertsDuressList);
  };

  handleDownloadTemperature = () => {
    downloadCSVFile(this.state.alertsTemperatureList);
  };

  render() {
    const tabs = [
      {
        id: 1,
        key: "duress",
        label: "Duress",
        icon: "fa-life-buoy",
        pending: this.state.pendingDuress,
        total: this.state.duressTotal,
      },
      {
        id: 2,
        key: "behaviour",
        label: "Behaviour",
        icon: "fa-exclamation-triangle",
        pending: this.state.pendingBehaviour,
        total: this.state.behaviourTotal,
      },
      {
        id: 3,
        key: "temperature",
        label: "Temperature",
        icon: "fa-thermometer-half",
        pending: this.state.pendingTemperature,
        total: this.state.temperatureTotal,
      },
    ];
    const activeTab = tabs.find((tab) => tab.id === this.state.activeTab) || tabs[0];

    return (
      <Layout>
        <Helmet>
          <title>Alert Centre </title>
        </Helmet>
        <div className="contentBody">
          <div className="contentWrapper contentWrapperSmoothRelease report-modern-page alert-centre-page">
            <div className="alertContent">
              <div className="reportHeaderTile alertCentreHeaderTile">
                <div className="headingContainer report-modern-header alertCentreHeader">
                  <div>
                    <h2 className="mainHeading">Alert Centre</h2>
                    <p>Monitor pending safety, behaviour and temperature events across the fleet.</p>
                  </div>
                  <div className={`alertCentreStatus ${activeTab.key}`}>
                    <span>{activeTab.label}</span>
                    <strong>{activeTab.pending}</strong>
                    <small>pending of {activeTab.total}</small>
                  </div>
                </div>
                <div className="alertCentreTabs" role="tablist" aria-label="Alert type">
                  {tabs.map((tab) => (
                    <button
                      key={tab.id}
                      type="button"
                      className={`alertCentreTab ${tab.key} ${this.state.activeTab === tab.id ? "activeTab" : ""}`}
                      onClick={() => this.handleTab(tab.id)}
                    >
                      <span className="alertCentreTabIcon">
                        <i className={`fa ${tab.icon}`} />
                      </span>
                      <span className="alertCentreTabText">
                        <strong>{tab.label}</strong>
                        <small>{tab.pending} pending</small>
                      </span>
                      <Badge pill variant={this.state.activeTab === tab.id ? "light" : "secondary"}>
                        {tab.total}
                      </Badge>
                    </button>
                  ))}
                </div>
              </div>
              {this.state.activeTab === 1 ? (
                <AlertTable
                  handleAcknowledege={this.handleAcknowledge}
                  alertMessage={`${this.state.pendingDuress} of ${this.state.duressTotal} alerts pending`}
                  data={this.state.alertsDuressList}
                  downloadExcel={this.handleDownloadDuress}
                />
              ) : this.state.activeTab === 2 ? (
                <AlertTable
                  handleAcknowledege={this.handleAcknowledge}
                  alertMessage={`${this.state.pendingBehaviour} of ${this.state.behaviourTotal} alerts pending`}
                  data={this.state.alertsBehaviourList}
                  downloadExcel={this.handleDownloadBehaviour}
                  rowColor={this.state.rowColor}
                />
              ) : (
                <AlertTable
                  handleAcknowledege={this.handleAcknowledge}
                  alertMessage={`${this.state.pendingTemperature} of ${this.state.temperatureTotal} alerts pending`}
                  data={this.state.alertsTemperatureList}
                  downloadExcel={this.handleDownloadTemperature}
                  rowColor={this.state.rowColor}
                  isTemperature={true}
                />
              )}
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(alerts);
